module.exports = __webpack_public_path__ + "static/gates-e9c1be1a3715c2b078020dde73ec0d60.jpg";